<template>
  <v-dialog
    v-if="!loadingData"
    v-model="show"
    max-width="600"
    overlay-color="darktext"
    overlay-opacity="0.6"
    disabled
  >
    <v-card
      data-testid="see-all-thread-member"
      class="pa-5"
    >
      <v-card-title>
        {{ $t('confirmationDialogTitleWorkflowActionUsers') }}
        <v-spacer />
        <v-icon
          ref="cancel"
          data-testid="cancel-button"
          min-width="100"
          class="rounded-xxl text-none mt-n8 mr-n4"
          style="z-index:1;"
          @click="$emit('close')"
        >
          mdi-close
        </v-icon>
      </v-card-title>
      <v-card-subtitle class="pb-8">
        {{ users.length  }} {{ $tc('peopleNumberTitle', users.length ) }}
      </v-card-subtitle>
      <v-divider />
      <div style="height:300px; overflow-y:auto;">
        <div       
          v-for="(user, index) in users"
          :key="index"
          class="list-item"
        >
          <v-list-item>
            <v-list-item-avatar>
              <v-avatar
                size="56"
                class="white--text"
              >
                <img
                  v-if="user.avatar_thumb == null"
                  src="../assets/user_images/profile-avatar.png"
                >
                <img
                  v-else
                  :src="`${user.avatar_thumb}`"
                >
              </v-avatar>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ user.first_name }} {{ user.last_name }}</v-list-item-title>
              <v-list-item-subtitle
                class="pt-0"
              >
                {{ user.email }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </div>

        <!-- <div
          v-if="users.length"
          v-observe-visibility="handleScrolledToBottom"
        /> -->
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { getWorkflowActionProgressForAction } from "../api/workflowApi";
//import i18n from '../plugins/i18n';

export default {
  components: {
  },
  props: {
    visible: Boolean,
    item: {
      type: Object,
      default: () => {}
    },
  },
  data(){
    return{
      loadingData: false,
      // usersInfo:[],
      // pageNumber: 1,
      // size: 15,
      // lastPage: 1,
      users: []
    }
  },  
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
    workflow() {
      return this.$store.state.workflow
    }
  },

  async created(){
    this.loadingData = true
    await this.getWorkflowActionUsers()
    this.loadingData = false
  },
  methods: {
    // handleScrolledToBottom (isVisible) {
    //   if (!isVisible) {
    //     return
    //   }
    //   if (this.pageNumber >= this.lastPage) {
    //     return
    //   }
    //   this.pageNumber++
    //   this.getWorkflowActionUsers()
    // },
    async getWorkflowActionUsers(){
      try {
        const response = await getWorkflowActionProgressForAction(this.workflow.id, this.item.id);
        if (response.status == 200) {
          if(response.data.meta.action_users){
            if(response.data.meta.action_users[this.item.id]){
              this.users =  response.data.meta.action_users[this.item.id];
            }
          }
          // this.users.push(...response.data.data)
          // this.usersInfo = response.data.meta
          // this.lastPage = response.data.meta.lastPage
        }
      } catch (e) {
        if (e.response) {
          this.$emit('proceedError')
        }
      }
    }
  }
}
</script>
